import {head, join, map, pipe, split, toUpper, take} from 'ramda';

export const getInitials: (name: string) => string = pipe(
  split(' '),
  take(2),
  map<string, string | undefined>(head),
  join(''),
  toUpper
);
